module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.656e92ca.jpeg";